module.exports = __webpack_public_path__ + "99e96898cd46c453d6415b168f9cc518.png";